import React, { PropTypes } from "react";
import { intlShape } from "react-intl";
import { Field, reduxForm } from "redux-form";
import classNames from "classnames";

import { TextInput } from "../form";

const TableQ = (props, context) => {
  function handleInputChange(event) {
    props.setQ(event.target.value);
  }

  function clear() {
    handleInputChange({ target: { value: "" } });
    props.reset();
  }

  const deleteButtonClasses = classNames({
    hidden: !props.q.length,
  });

  const { formatMessage } = context.intl;

  return (
    <div className="datatable-search search-input">
      <Field
        id="q"
        name="q"
        type="text"
        component={TextInput}
        placeholder={formatMessage({ id: "datatable.search.placeholder" })}
        props={{ onChange: handleInputChange }}
      />
      <button className={deleteButtonClasses} onClick={clear}>
        <span className="icon-cross" />
      </button>
    </div>
  );
};

TableQ.propTypes = {
  q: PropTypes.string.isRequired,
  reset: PropTypes.func,
  setQ: PropTypes.func.isRequired,
};

TableQ.contextTypes = {
  intl: intlShape,
};

export default reduxForm({
  form: "tableQ", // a unique identifier for this form
})(TableQ);



// WEBPACK FOOTER //
// ./src/components/common/DataTable/TableQ.js